// removed by extract-text-webpack-plugin
module.exports = {"OrderBookMini":"OrderBookMini","TabContent":"TabContent","NavTab":"NavTab","OrderBookButton":"OrderBookButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/OrderBook/OderBookMini/styles.scss
// module id = 2016
// module chunks = 10